import React from 'react';

const BeforeAfter3 = (props) => {
  const containerStyle = {
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
    textAlign: 'center',
  };

  const titleStyle = {
    fontSize: '2rem',
    marginBottom: '20px',
  };

  const comparisonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    position: 'relative',
  };

  const beforeContainerStyle = {
    width: '50%',
    position: 'relative',
  };

  const afterGridStyle = {
    width: '300px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr 1fr',
    gap: '2px',
    position: 'relative',
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };

  const labelStyle = {
    position: 'absolute',
    padding: '8px 15px',
    background: 'rgba(0, 0, 0, 0.7)',
    color: 'white',
    fontWeight: 'bold',
    borderRadius: '4px',
    zIndex: 2,
  };

  const labelBeforeStyle = {
    ...labelStyle,
    bottom: '15px',
    left: '15px',
  };

  const labelAfterStyle = {
    ...labelStyle,
    bottom: '15px',
    right: '15px',
  };

  return (
        <div className="project-card">
                    <div className="project-title">
      <h2 >{props.title}</h2></div>     
       <div style={comparisonContainerStyle}>
        {/* BEFORE - single image */}
        <div className='before-container' style={{width:'300px'}}>
          <img src={props.i1} alt="Before" style={imageStyle} />
                  <div className="label before">Avant</div>
        </div>

        {/* AFTER - 2x2 grid of images */}
        <div style={afterGridStyle}>
          {[props.i2, props.i3, props.i4, props.i5].map((src, idx) => (
            <div key={idx}>
              <img src={src} alt={`After ${idx + 1}`} style={imageStyle} />
            </div>
          ))}
        <div className="label after after2">Après</div>        </div>
      </div>
    </div>
  );
};

export default BeforeAfter3;
